import { ChangeDetectionStrategy, Component, Input, OnInit, HostBinding } from '@angular/core';
import { FormControl } from '@angular/forms';
import { isEmpty } from 'lodash';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { switchMap, debounceTime, distinctUntilChanged, tap, finalize } from 'rxjs/operators';
import { Project } from '../../../shared';
import { Accession } from './../../../shared/accession';
import { AccessionsStorage } from './../../../shared/accessions-storage';

@Component({
    selector: 'accession-select',
    template: require('./accession-select.component.html'),
    styles: [require('./shared/select.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessionSelectComponent implements OnInit {
    @Input()
    public control: FormControl;

    @Input()
    public set projects(projects: Project[]) {
        this.projects$.next(projects);
        this.control.setValue([]);

        this.disabled = isEmpty(projects);
        
        if (this.disabled) {
            this.control.disable();
        } else {
            this.control.enable();
        }
    }

    @Input()
    @HostBinding('class.disabled')
    public disabled = false;

    public readonly searchFlow$ = new Subject<string>();
    public readonly isSearching$ = new BehaviorSubject(false);
    public readonly selectStyle = { 'max-height': '15vh' };

    public selectedAccessions$: Observable<Accession[]>;
    public accessions$: Observable<Accession[]>;
    private projects$ = new BehaviorSubject<Project[]>([]);

    constructor(private accessionsStorage: AccessionsStorage) { }

    public ngOnInit() {
        this.accessions$ = this.searchFlow$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => this.isSearching$.next(true)),
            switchMap(searchTerm => this.projects$.pipe(switchMap(projects =>
                isEmpty(projects)
                    ? of([] as Accession[])
                    : this.accessionsStorage.search(projects[0].subProtocolId, searchTerm)
            ))),
            tap(() => this.isSearching$.next(false)),
            finalize(() => this.isSearching$.next(false))
        );

        this.selectedAccessions$ = this.control.valueChanges.pipe(distinctUntilChanged());
    }

    public onSelectedItemChange(selectedItem: Accession[]) {
        this.control.setValue(selectedItem);
    }
}